import React from 'react'
import * as styles from './FormErrorMessage.scss'

const FormErrorMessage = ({ messages = [] }) => messages.length > 0 ? (
  <div className={styles.root}>{messages.join('\n')}</div>
) : null

export default FormErrorMessage
